export enum ErrorLoginMessageEnum {
    EXPIRED_USER = "expired_user",
    INVALID_USER = "invalid_user",
    INACTIVE_USER = "inactive_user",
    INVALID_PASSWORD = "invalid_password",
    SHIFT_TIME_ACTIVE = "login_unavailable_shifts",
};
